export default function CampusMapTabs({ campuses, campusKey, onChange }) {
  return (
    <section className="campus-map-tabs" data-testid="campus-map-tabs">
      {Object.entries(campuses).map(([key, value]) => (
        <button
          aria-pressed={campusKey === key}
          className={campusKey === key ? "active" : ""}
          data-testid={`campus-map-tab-${key}`}
          key={key}
          onClick={() => onChange(key)}
          type="button"
        >
          {value.label}
        </button>
      ))}
    </section>
  );
}